import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

const CityList = ({cities, onSelect}) => {
    
    if (!cities?.length) return <></>;

    const handleSelect = city => {
        onSelect(city);
    }
    
    return <List>
        {
            cities?.map(city => {
                return <ListItem
                    key={`city-list-${city.id}`}
                    onClick={() => {handleSelect(city)}}
                    button
                    >
                        {`${city.name}, ${city.county}`}
                    </ListItem>
            })
        }
    </List>
};

export default  CityList;